import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

const api = '/api/campus/'
const mpi = '/api/campus-manager/'
const gpi = '/api/campus-grading/'
const bpi = '/api/campus-bank/'
const get = axios.get
const post = axios.post

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const res = await request
    return res.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data)
  }
}

export const ListCampus = createAsyncThunk('campus-list', (params: {}, thunkAPI) =>
  handleRequest(get(`${api}list`, params), thunkAPI)
)

export const createCampus = createAsyncThunk('add-campus', (data: {}, thunkAPI) =>
  handleRequest(post(`${api}store`, data), thunkAPI)
)

export const editCampus = createAsyncThunk('campus-edit', (id: string, thunkAPI) =>
  handleRequest(get(`${api}edit/${id}`), thunkAPI)
)

export const viewCampus = createAsyncThunk('campus-show', (id: string, thunkAPI) =>
  handleRequest(get(`${api}show/${id}`), thunkAPI)
)

export const deleteCampus = createAsyncThunk('campus-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`${api}destroy/${id}`), thunkAPI)
)

export const ListCampusManager = createAsyncThunk('campus-mgr-list', (params: {}, thunkAPI) =>
  handleRequest(get(`${mpi}list`, params), thunkAPI)
)

export const createCampusManager = createAsyncThunk('add-campus-mgr', (data: {}, thunkAPI) =>
  handleRequest(post(`${mpi}store`, data), thunkAPI)
)

export const editCampusManager = createAsyncThunk('campus-mgr-edit', (id: string, thunkAPI) =>
  handleRequest(get(`${mpi}edit/${id}`), thunkAPI)
)

export const activeCampusManager = createAsyncThunk('campus-mgr-active', (id: string, thunkAPI) =>
  handleRequest(get(`${mpi}active/${id}`), thunkAPI)
)

export const inactiveCampusManager = createAsyncThunk(
  'campus-mgr-inactive',
  (id: string, thunkAPI) => handleRequest(get(`${mpi}inactive/${id}`), thunkAPI)
)

export const ListCampusGrading = createAsyncThunk('campus-grading', (_, thunkAPI) =>
  handleRequest(get(`${gpi}list`), thunkAPI)
)

export const createCampusGrading = createAsyncThunk('add-campus-grading', (data: {}, thunkAPI) =>
  handleRequest(post(`${gpi}store`, data), thunkAPI)
)

export const editCampusGrading = createAsyncThunk('grading-edit', (id: string, thunkAPI) =>
  handleRequest(get(`${gpi}edit/${id}`), thunkAPI)
)

export const ListCampusBank = createAsyncThunk('campus-banks', (params: {}, thunkAPI) =>
  handleRequest(get(`${bpi}list`, params), thunkAPI)
)

export const createCampusBank = createAsyncThunk('add-campus-bank', (data: {}, thunkAPI) =>
  handleRequest(post(`${bpi}store`, data), thunkAPI)
)

export const editCampusBank = createAsyncThunk('bank-edit', (id: string, thunkAPI) =>
  handleRequest(get(`${bpi}edit/${id}`), thunkAPI)
)

export const deleteCampusBank = createAsyncThunk('bank-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`${bpi}destroy/${id}`), thunkAPI)
)

type CampusState = {
  record: any
  records: any
  errors: any
}

const initialState: CampusState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const campusSlice = createSlice({
  name: 'campus',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(ListCampus.fulfilled, (state, action: PayloadAction<any>) => {
      state.records = action.payload
    })
  },
})

export const {reset} = campusSlice.actions
export default campusSlice.reducer
